import { i18n } from '../index'

// 快捷翻译方法
export function $t(key, params = {}) {
  return i18n.t(key, params)
}

// 带命名空间的翻译
export function $tNs(namespace) {
  return (key, params) => i18n.t(`${namespace}.${key}`, params)
}

// 获取当前语言
export function getCurrentLang() {
  return i18n.locale
}